import styled from 'styled-components';
import { useRecentViewExpericeProducts } from '../../hooks/useRecentViewExpericeProducts';
import RecentViewList from '../common/RecentViewList';
import SectionTitle from '../common/SectionTitle';

export default function RecentViewSection() {
  const { recentViewExpericeProducts } = useRecentViewExpericeProducts();
  return (
    <Container>
      <SectionTitle title={'최근 본 상품'} slogan={''} />
      <RecentViewList products={recentViewExpericeProducts} />
    </Container>
  );
}

const Container = styled.div`
  margin-top: 80px;
  width: 100%;
`;
